import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={49} height={48} viewBox="0 0 49 48" fill="none" {...props}>
        <Path
            d="M22.5 24C22.5 25.1046 23.3954 26 24.5 26C25.6046 26 26.5 25.1046 26.5 24L26.5 16C26.5 14.8954 25.6046 14 24.5 14C23.3954 14 22.5 14.8954 22.5 16L22.5 24Z"
            fill={props.color ?? ds.colorValue.background.danger.strong}
        />
        <Path
            d="M24.5 29C23.1192 29 22 30.1193 22 31.5C22 32.8807 23.1192 34 24.5 34C25.8808 34 27 32.8807 27 31.5C27 30.1193 25.8808 29 24.5 29Z"
            fill={props.color ?? ds.colorValue.background.danger.strong}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.5 44C35.5457 44 44.5 35.0457 44.5 24C44.5 12.9544 35.5457 4 24.5 4C13.4544 4 4.5 12.9544 4.5 24C4.5 35.0457 13.4544 44 24.5 44ZM40.5 24C40.5 32.8366 33.3366 40 24.5 40C15.6634 40 8.5 32.8366 8.5 24C8.5 15.1634 15.6634 8 24.5 8C33.3366 8 40.5 15.1634 40.5 24Z"
            fill={props.color ?? ds.colorValue.background.danger.strong}
        />
    </Svg>
);

export default SvgComponent;
